import { enqueueDemoOrganizationResetJob } from "../../../../../../../../../../../../../../../../../api/kehrblatt/demo-data"
import type { StartDemoResetOperations } from "../../../actions/startDemoReset"
import { buildDemoResetRequest } from "../build-request"

export const startDemoResetOperations: StartDemoResetOperations = {
  enqueue: ({ organizationId, primary, secondary, idempotencyKey, signal }) =>
    enqueueDemoOrganizationResetJob(organizationId, buildDemoResetRequest(primary, secondary), {
      idempotencyKey,
      signal,
    }),
}
